const generateUserLabel = (firstName, surname, userName) => {
    const tempFirstName = firstName ? `${firstName} ` : '';
    const tempSurname = surname ? `${surname} ` : '';
    return ((tempFirstName + tempSurname).length > 0) ? `${tempSurname}${tempFirstName}(${userName})` : userName;
}

export default generateUserLabel;